import { defineComponent as _defineComponent } from 'vue';
import { onMounted, ref, computed } from 'vue';
import { route } from 'ziggy-js';
import InvoiceOrders from '../shared/InvoiceOrders.vue';
import BrandBalanceAlert from "../shared/BrandBalanceAlert.vue";
import { getErrorMessage } from "@js/api/utils/request-helpers";
import { getInvoiceDetail } from "@js/api/domain/invoice";
import { groupInvoiceLines } from "@js/vue/domain/invoice/utils/invoice-grouping";
import { formatCurrency } from "@js/utilities/formatters";
import { ArrowLeft, ArrowRight, Folder, Printer, Tag } from 'lucide-vue-next';
import { useUserStore } from "@js/vue/domain/user/stores/useUserStore";
import InvoiceStatus from "@js/vue/domain/invoice/components/shared/InvoiceStatus.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DetailLayout',
    props: {
        id: { type: [Number, String], required: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const userStore = useUserStore();
        const currentInvoice = ref(null);
        const fortyCompanyInfo = ref(null);
        const isLoading = ref(false);
        const error = ref(null);
        const groupedLines = computed(() => {
            if (!currentInvoice.value)
                return [];
            return groupInvoiceLines(currentInvoice.value.lines ?? [], currentInvoice.value.orders ?? []);
        });
        const resetState = () => {
            currentInvoice.value = null;
            fortyCompanyInfo.value = null;
            error.value = null;
        };
        const fetchInvoiceDetail = async (id) => {
            resetState();
            isLoading.value = true;
            try {
                const { data } = await getInvoiceDetail(id);
                currentInvoice.value = data.invoiceDetail;
                fortyCompanyInfo.value = data.companyInfo;
            }
            catch (err) {
                resetState();
                error.value = getErrorMessage(err);
            }
            finally {
                isLoading.value = false;
            }
        };
        const triggerPrint = () => {
            window.print();
        };
        onMounted(() => {
            fetchInvoiceDetail(Number(props.id));
        });
        const __returned__ = { props, userStore, currentInvoice, fortyCompanyInfo, isLoading, error, groupedLines, resetState, fetchInvoiceDetail, triggerPrint, get route() { return route; }, InvoiceOrders, BrandBalanceAlert, get formatCurrency() { return formatCurrency; }, get ArrowLeft() { return ArrowLeft; }, get ArrowRight() { return ArrowRight; }, get Folder() { return Folder; }, get Printer() { return Printer; }, get Tag() { return Tag; }, InvoiceStatus };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
